export default __webpack_public_path__ + "static/media/womenCoatSkirt.0293728d.svg";